import {Component, NgModule, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})


export class AppComponent implements OnInit {
  constructor(translate: TranslateService) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('ger');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('ger');
  }

  public ngOnInit() { }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts